export default "__VITE_ASSET__309g6mMk__"